<template>
  <!--
    Tijdens het laden houdt de plek zijn maat, zodat de rechterkolom van de
    kaart niet van leeg naar vol springt. Blijkt het tijdslot daarna leeg, dan
    klapt de rij helemaal dicht — geen kop, geen uitnodiging (ADR-0060).
  -->
  <div
    v-if="loading || shown.length > 0"
    class="slot-participants"
    :style="loading ? reserveStyle : null"
  >
    <template v-if="!loading">
      <v-tooltip
        v-for="person in shown"
        :key="person.user_id"
        class="rounded-tooltip"
        location="top"
      >
        <template v-slot:activator="{ props }">
          <span v-bind="props" class="slot-participants__face">
            <participant-avatar :person="person" :size="size" />
          </span>
        </template>
        <span class="tooltip-text">{{ fullName(person) }}</span>
      </v-tooltip>

      <!--
        @click.stop: de hele kaart is het klikdoel dat het tijdslot selecteert.
        Zonder stop kiest een klik op de bubbel ook meteen dit tijdslot.
      -->
      <button
        v-if="overflow > 0"
        type="button"
        class="slot-participants__face slot-participants__more"
        :style="{ width: `${size}px`, height: `${size}px` }"
        :aria-label="$t('deelnemers.view')"
        @click.stop="$emit('open')"
      >
        +{{ overflow }}
      </button>
    </template>
  </div>
</template>

<script>
import ParticipantAvatar from "@/components/participant-avatar.vue";
import { fullNameFor, splitForRow } from "@/util/participants";

/**
 * De deelnemersrij op één tijdslotkaart in de Datumkiezer.
 *
 * Krijgt de deelnemers van dát tijdslot aangereikt — de kaart biedt één
 * tijdslot aan, dus toont hij die mensen en niet de activiteitbrede rij van de
 * activiteitenpagina (ADR-0060). Haalt zelf niets op: één read voedt alle
 * kaarten, anders zou elke kaart hetzelfde endpoint aanroepen.
 */
export default {
  name: "SlotParticipantsRow",

  components: { ParticipantAvatar },

  props: {
    participants: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    // Het ontwerp geeft de kaartrij 160px: vijf bollen van 40px met 16px
    // overlap, plus de +N-bubbel op de zesde plek.
    size: { type: Number, default: 40 },
    limit: { type: Number, default: 5 },
  },

  emits: ["open"],

  computed: {
    split() {
      return splitForRow(this.participants, this.limit);
    },

    shown() {
      return this.split.shown;
    },

    overflow() {
      return this.split.overflow;
    },

    // Alleen tijdens het laden: zes plekken naast elkaar met 16px overlap,
    // 40 + 5 × 24 = 160px. Daarna krijgt de rij zijn eigen breedte, anders
    // staat één deelnemer links in een lege doos van 160px in plaats van
    // rechts uitgelijnd boven de chip en het info-icoon.
    reserveStyle() {
      const step = this.size - 16;

      return {
        minWidth: `${this.size + this.limit * step}px`,
        minHeight: `${this.size}px`,
      };
    },
  },

  methods: {
    fullName(person) {
      return fullNameFor(person);
    },
  },
};
</script>
